import i18n from '@flowus/common/i18n';

const { VITE_PRODUCT_AI_NAME, VITE_PRODUCT_NAME, VITE_PRODUCT_ALL_NAME } = import.meta.env;

export const PRODUCT_AI_TITLE = VITE_PRODUCT_AI_NAME;
export const PRODUCT_AI_TITLE_BUILDIN = i18n.t('const.title.space_ai_query_quota');
export const PRODUCT_AI_PAY_TITLE = i18n.t('const.title.ai_monthly_benefits');
export const PRODUCT_NAME = VITE_PRODUCT_NAME;
export const PRODUCT_ALL_NAME = VITE_PRODUCT_ALL_NAME;
